import React from 'react'
import "../../../styles/servicios/servicios.css"
import Logo from "../../Reutilizables/Logo"
import MenuServicios from './Menu_servicios'
import Redes from '../../Reutilizables/Redes'
import TituloImpuestosMunicipales from '../../Reutilizables/TituloImpuestosMunicipales'

function Servicios() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <MenuServicios />
      </div>
      <div className='tittle-menu-servicios'>
        <TituloImpuestosMunicipales />
      </div>
      <Redes />
    </>
  )
}

export default Servicios